import React from 'react';
import { Result, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { isSessionValid } from '../../Utils/session';

/**
 * Public Stripe cancellation redirect. Handoff Flow E: works with no query
 * params, changes no payment state. Offers a return to invoices (where the CFO
 * can retry using the existing checkout link).
 */
const PaymentCancelled = () => {
  const navigate = useNavigate();
  const authed = isSessionValid();
  return (
    <div className="auth-viewport">
      <div className="auth-card" style={{ maxWidth: 520 }}>
        <Result
          status="warning"
          title="Payment not completed"
          subTitle="The payment was not completed. You can retry the payment from the invoice using its existing checkout link."
          extra={
            <Space>
              {authed && (
                <Button type="primary" onClick={() => navigate('/cfo/invoices')}>
                  Return to Invoices
                </Button>
              )}
            </Space>
          }
        />
      </div>
    </div>
  );
};

export default PaymentCancelled;
